import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSortieSecours = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.3796 5.81892C9.28687 5.81892 9.44139 2.99997 11.2515 2.99997C13.097 2.99997 13.1433 5.81892 11.3796 5.81892ZM14.1014 9.58488L14.1168 10.6886L11.9469 10.5738L11.4149 9.79018L12.2537 8.11249L12.8674 9.27583L14.1014 9.58488ZM14.8431 17.1367V1.76819L4.31121 1.84545V12.8078L6.66659 12.4899L8.62021 7.73501L7.42155 7.71515L5.83437 10.3641C5.83437 10.3641 4.9293 10.1191 5.33106 9.11248C5.73283 8.10587 6.60699 6.21406 6.60699 6.21406L9.6798 6.10589C9.6798 6.10589 11.1765 6.32664 11.682 7.0529L10.5429 10.5054L12.2471 12.8078L12.9093 16.6687H12.9248L10.9381 18.7592L8.84096 18.7746L11.5849 16.3883L10.7725 13.4458L9.10806 11.9668L7.70852 14.0881L3.41718 14.0153L3.19643 14.7018L4.30017 15.1102V17.3177L2.68209 18.6952L0.0816765 18.6532L0 0L18.7172 0.0728473L18.7459 18.6863L13.4193 18.7327L14.8431 17.1367Z",
		fill: "#32D399"
	})
});
export default SvgSortieSecours;
